import { observer } from 'mobx-react'
import { FC, useEffect, useState } from 'react'

import { CheckPicker } from '@avantstay/backoffice-core'

import { RegionsStore } from '@stores/RegionsStore'

interface PropertiesFilterProps {
  dataCy?: string
  initialValue?: string[]
  onChange: (value?: string[]) => void
  placeholder?: string
  hideOptionAll?: boolean
}

const _PropertiesFromRegionsFilter: FC<PropertiesFilterProps> = ({
  dataCy,
  initialValue,
  onChange,
  placeholder,
  hideOptionAll = false,
}) => {
  const { selectedRegionsIds, propertiesOptions, isLoadingProperties } = RegionsStore

  const isSelectDisabled = !selectedRegionsIds || selectedRegionsIds?.length === 0

  const [selectedProperties, setSelectedProperties] = useState<string[] | undefined>(initialValue)

  useEffect(() => {
    if (initialValue === undefined) {
      setSelectedProperties(undefined)
    }
    if (!!initialValue && initialValue !== selectedProperties) {
      setSelectedProperties(initialValue)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValue])

  const handleSelect = (value: string[]) => {
    setSelectedProperties(value)
    onChange(value)
  }

  return (
    <CheckPicker.SmallNew
      data-cy={dataCy}
      searchable
      disabled={isSelectDisabled}
      options={propertiesOptions ?? []}
      placeholder={placeholder}
      value={selectedProperties || []}
      hideOptionAll={hideOptionAll}
      onChange={handleSelect}
      isLoadingOptions={isLoadingProperties}
    />
  )
}

export const PropertiesFromRegionsFilter = observer(_PropertiesFromRegionsFilter)
